import { Injectable } from '@angular/core';

import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { Store } from '@ngxs/store';

import { UserService } from '@smarthead-api/services/user.service';

import { LanguageService } from './language.service';

import { AppState } from '../../../../client/src/app/shared/state/app.state';
import { SharedUtils } from '../../../../client/src/app/shared/utils/shared-utils';

@Injectable({
  providedIn: 'root'
})
export class UserLanguageService {
  constructor(
    private store: Store,
    private languageService: LanguageService,
    private userService: UserService
  ) {
    this.languageService.languageChangedByUser$
      .pipe(
        switchMap(code => {
          const loggedUser = this.store.selectSnapshot(AppState.getUserData);
          if (loggedUser?.id) {
            return this.userService
              .patchUser({
                id: loggedUser.id,
                body: {
                  language: SharedUtils.languageAsStringToEnum(code)
                }
              })
              .pipe(map(() => true));
          }
          return of(false);
        })
      )
      .subscribe();
  }
}
